import $ from 'jquery';
import {dependency} from "../utils/request";
import {getWidth, onResize} from "../utils/window";

// import 'moment';
// import Pikaday from 'pikaday';

export default function booknowSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	if ($('#content.contact').length) {

		let vehicleSelectField = $('[name="message[Selected Vehicle]"]');
		let vehicleSelector = $('#vehicleSelector');
		let vehicles = $('.booknow_form_vehicles .booknow_form_vehicles-vehicle');

		function parse_query_string(query) {
			let vars = query.split("&");
			let query_string = {};
			for (let i = 0; i < vars.length; i++) {
				let pair = vars[i].split("=");
				let key = decodeURIComponent(pair[0]);
				let value = decodeURIComponent(pair[1]);
				// If first entry with this name
				if (typeof query_string[key] === "undefined") {
					query_string[key] = decodeURIComponent(value);
					// If second entry with this name
				} else if (typeof query_string[key] === "string") {
					query_string[key] = [query_string[key], decodeURIComponent(value)];
					// If third or later entry with this name
				} else {
					query_string[key].push(decodeURIComponent(value));
				}
			}
			return query_string;
		}

		function updateVehicleSelector(data = null) {
			vehicleSelector.val(data === null ? '': data);
			vehicleSelector.change();
		}

		function setupSelectedOnLoad() {
			let query = window.location.search.substring(1);
			let qs = parse_query_string(query);

			vehicles.each(function () {
				let _this = $(this);
				let _a = _this.find('> a');

				if (_a.attr('data-id') === qs.id) {
					_this.addClass('is-selected');
					setupVehicleSelectField(vehicleSelectField);
				}
			});

			if ($('.booknow_form_vehicles-vehicle.is-selected').length) {
				// $(window).on('load', function () {
				// 	$scroller.animate({
				// 		scrollTop: $('#booknow').offset().top
				// 	}, 700);
				// });

				$scroller.animate({
					scrollTop: $('#booknow').offset().top
				}, 700);

				window.addEventListener('unload', function(e) {
					//set scroll position to the top of the page.
					window.scrollTo(0, 0);
				});
			}
		}

		function setupVehicleSelectField(field) {
			vehicles.each(function () {
				let vehicle = $(this);

				if (vehicle.hasClass('is-selected')) {
					field.attr('value', vehicle.find('> a').attr('data-name'));
					updateVehicleSelector(vehicle.find('> a').attr('data-name'));
				}
			});
		}

		function vehicleClickEvent(e) {
			e.preventDefault();

			if ($(this).parent().hasClass('is-selected')) {
				$(this).parent().toggleClass('is-selected');
				vehicleSelectField.attr('value', '');
				updateVehicleSelector();
			} else {
				vehicles.removeClass('is-selected');
				$(this).parent().toggleClass('is-selected');
			}

			setupVehicleSelectField(vehicleSelectField);
		}

		function vehicleSelectEvent(e) {
			let _this = $(this);
			let val = _this.val();

			vehicles.removeClass('is-selected');
			if (val !== '') {
				$('.booknow_form_vehicles').find(`[data-name="${val}"]`).parent().addClass('is-selected');
				vehicleSelectField.attr('value', val);
			} else {
				vehicleSelectField.attr('value', '');
			}
		}

		function setupEvents() {
			$('[href="selectVehicle"]').off('click', vehicleClickEvent);
			vehicleSelector.off('change', vehicleSelectEvent);

			if(getWidth() > 780) {
				$('[href="selectVehicle"]').click(vehicleClickEvent);
			} else {
				vehicleSelector.on('change', vehicleSelectEvent);
			}
		}

		setupSelectedOnLoad();
		setupEvents();

		onResize(()=>{
			setupEvents();
		});

		dependency('https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/moment.min.js')
		dependency('https://cdn.jsdelivr.net/npm/pikaday/pikaday.js', () => window.moment && window.Pikaday).then(function () {
			// after success
			// add the pikaday css file
			let link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = 'https://cdn.jsdelivr.net/npm/pikaday/css/pikaday.css';
			document.head.appendChild(link);

			let dateFields = [document.getElementById('pickup-date'), document.getElementById('dropoff-date')];
			let pikaDates = [];

			if (dateFields.length) {
				dateFields.forEach((val, index, array) => {
					let pikaDate = new Pikaday({
						field: val,
						format: 'D/M/YYYY',
						toString(date, format) {
							// you should do formatting based on the passed format,
							// but we will just return 'D/M/YYYY' for simplicity
							const day = date.getDate();
							const month = date.getMonth() + 1;
							const year = date.getFullYear();
							return `${day}/${month}/${year}`;
						},
						parse(dateString, format) {
							// dateString is the result of `toString` method
							const parts = dateString.split('/');
							const day = parseInt(parts[0], 10);
							const month = parseInt(parts[1], 10) - 1;
							const year = parseInt(parts[2], 10);
							return new Date(year, month, day);
						}
					});
					pikaDates.push(pikaDate);
				});
			}
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/booknow.js